import axios from 'axios'
import { SAVINGS_PLAN_SUBSCRIPTION_ENDPOINT } from 'cfgCommon/endpoints'

export async function getAllSavingsPlanSubscriptions(params) {

const endpoint = `${SAVINGS_PLAN_SUBSCRIPTION_ENDPOINT}/${params.replace('car_lot_id', 'carLotId')}`
    try {
        const res  = await axios.get(endpoint)
        return res.data
    } catch {
        console.log('error');
        return []
    }
}
